import { faGear, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Menu, Typography, MenuItem } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { config } from "../../config/config";
import { useTheme } from "@mui/material";

import BLANK_USER from "../../../images/icons/blank-user.svg";

interface Props {
  userLang: string;
  username: string;
  mail: string;
  pic: String;
}

export const UserMenu = ({ userLang, username, mail, pic }: Props) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  //SCアカウント設定
  const handleOpenAccountPage = () => {
    window.open(process.env.REACT_APP_ACCOUNT_SERVER_URL, "_blank");
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
    borderColor: theme.palette.base.border,
  };

  const customMenuStyles = {
    background: theme.palette.base.menu,
  };

  return (
    <>
      <IconButton
        className="del-pj19"
        onClick={handleClick}
        sx={{ padding: "0px 8px" }}
      >
        <img
          src={pic ? String(pic) : BLANK_USER}
          style={{
            borderRadius: "50%",
            height: "2rem",
            width: "2rem",
          }}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ top: "0px", borderRadius: "0px" }}
        PaperProps={{ className: "del-pj18", style: customMenuStyles }}
      >
        <div
          style={{
            padding: "1rem",
            borderBottom: "1px solid var(--gray)",
            marginBottom: "0.5rem",
            textAlign: "left",
          }}
        >
          <Typography variant="h6">{username ?? { username }}</Typography>
          <Typography variant="body2">{mail ?? { mail }}</Typography>
        </div>

        <MenuItem
          onClick={handleOpenAccountPage}
          style={{ whiteSpace: "normal", textAlign: "left" }}
        >
          <FontAwesomeIcon
            icon={faGear}
            style={{
              width: "16px",
              height: "16px",
              marginRight: "10px",
              ...customColor,
            }}
          />
          {t("MANAGE_MY_SMART_CONSTRUCTION_ACCOUNT")}
        </MenuItem>
      </Menu>
    </>
  );
};
